import AppTooltip from "../../elements/AppTooltip";

interface Props {
  field: any;
}

export default function CalculatedCreate({ field }: Props) {
  const formula =
    field?.CalculatedFieldData?.PlainText ?? "No Formula Provided.";

  return (
    <AppTooltip useTooltip content={`${field?.Name} = ${formula}`}>
      <div
        style={{
          height: "calc( 0.45em + 1.25rem + 5px)",
          borderRadius: "0.25rem",
          fontSize: "0.875rem",
          lineHeight: 1.5,
          padding: "0.25rem 0.5rem",
          overflow: "hidden",
          whiteSpace: "nowrap",
          textOverflow: "ellipsis",
          background: "unset",
          cursor: "not-allowed",
        }}
        className="border"
      >
        <span className="text-primary font-weight-500">{formula}</span>
      </div>
    </AppTooltip>
  );
}
